import React, { useContext, useState, useEffect } from 'react';

import { observer } from 'mobx-react-lite';
import DOMPurify from 'dompurify';

import DocumentPreview from 'components/common/DocumentPreview/DocumentPreview';
import { RootStoreContext } from 'index';
import Spinner from 'components/common/Spinner/Spinner';

const MdaPreviewPage = () => {
  const [masterDealerAgreementDocument, setMasterDealerAgreementDocument] = useState('');
  const { intermediaryApplicationsStore } = useContext(RootStoreContext);

  useEffect(() => {
    const getMasterDealerAgreement = async () => {
      const document = await intermediaryApplicationsStore.getMasterDialerAgreement();

      setMasterDealerAgreementDocument(document);
    };

    getMasterDealerAgreement();
  }, []);

  return intermediaryApplicationsStore.isMasterDialerAgreementLoading ? (
    <Spinner />
  ) : (
    <DocumentPreview title={'Master Dealer Agreement'} handleBack={() => window.close()}>
      <div
        className="content"
        dangerouslySetInnerHTML={{
          __html: DOMPurify.sanitize(masterDealerAgreementDocument, { FORCE_BODY: true }),
        }}
      ></div>
    </DocumentPreview>
  );
};

export default observer(MdaPreviewPage);
